module.exports = __webpack_public_path__ + "6ebdc0f1bf1570e45f57de3f8f741e45.png";